import React, { FunctionComponent, useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import actions from '@state/actions';
import { IUserAccess, UserStatus } from '@state/userAccess/types';
import { AuthContext } from './AuthContext';
import { USER_ACCESS_FILTERS } from '@utils/userAccess';

export const UserAccessContext = React.createContext({} as any);

export interface UserAccessProviderProps {
    location: string;
}

export const UserAccessProvider: FunctionComponent<any> = (props: React.PropsWithChildren<UserAccessProviderProps>) => {
    const [hasDesigns, setHasDesigns] = useState(false);
    const [isLookingForDesigns, setIsLookingForDesigns] = useState(false);
    const [location, setLocation] = useState(props.location);
    const [searching, setSearching]= useState(false);
    const [searchQuery, setSearchQuery]= useState('');
    const [showCounter, setShowCounter]= useState(true);
    const [value, setSearchValue]= useState('');
    const [deleteId, setDeleteId]= useState('');
    const [showList, setShowList]= useState(props.location==='studio'?false:true);
    const [spinner, setSpinner]=useState(true);
    const [userAccessDetail, setUserAccessDetail]=useState<IUserAccess[]>([]);
    const [forceSearch, setForceSearch]= useState(false);
    const [sortByMenu] = useState(USER_ACCESS_FILTERS);

    const [sortByText, setSortByText]=useState('');

    const [filtering, setFiltering]= useState(false);
    const [filterQuery, setFilterQuery]= useState('');

    const [move, setMove]= useState(false);

    const [counterQuery, setCounterQuery]= useState('');    

    const authContext = useContext(AuthContext);
    const dispatch = useDispatch();


    useEffect(() => {
        if(location=='studio' && !hasDesigns && filtering && !move)setMove(true);
    }, [filtering])


    const showListemplates=(val:boolean)=>{
        if(location==='studio')setShowList(val);
    }

    const handleFiltering=(val:boolean)=>{
        if(location==="studio"){
            if(move && !filtering)setMove(false);
            
            if(val!=filtering){
                if(value==='')setShowList(val);
                else setShowList(true);
            }
        }
        setFiltering(val);
    }

    const fetchCounter = (userdata?:string) => {
        if(counterQuery!==''){
            dispatch(actions.templates.setCounter({} as any));

            return new Promise((resolve, reject) => {
                dispatch(actions.templates.fetchCounter(encodeURI('?filter='+counterQuery+'&userdata='+userdata)+"&all=true",(result, error) => {
                    if (error) reject(error)
                    else resolve(result);
                }))
            });
        }
    }

    const getQuerySearchFilters = (filters:string) => {
        const state=location==='studio'?`='PUBLISHED'`:`<>'INACTIVE'`;
        let query='';

        if(filtering && searching){
            query=`(c.templateStatus${state} and c.formatName LIKE "%${value.toLowerCase()}%" and ${filters}) or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus) and c.templateStatus${state} ${filters!=="" ? `and${filters}`:``})`;
        }
        else if (filtering && filters!==''){
            query=`(c.templateStatus${state} and ${filters})`;
        }
        else if (searching){
            query=`(c.templateStatus${state} and c.formatName LIKE "%${value.toLowerCase()}%") or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus) and c.templateStatus${state})`;
        }
        setCounterQuery(query);
        return query;
    }

    const clearDeletedUserAccess = ()=>{
        dispatch(actions.userAccess.clearDeleteUserAccess());        
    }


    const deleteUserAccess = async (id:string) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        
        let delItem : IUserAccess = {
            id: id,
            user:userData,
            status: UserStatus.INACTIVE,
            createdBy: userData,
            updatedBy: userData
        } ;                  

        dispatch(actions.userAccess.deleteUserAccess(delItem));        
    }

    return (
        <UserAccessContext.Provider value={{
            searching,
            setSearching: (val:boolean,)=>setSearching(val),
            forceSearch,
            setForceSearch: (val:boolean)=>setForceSearch(val),
            searchQuery,
            setSearchQuery: (val:string)=>setSearchQuery(val),
            showCounter,
            setShowCounter: (val:boolean)=>setShowCounter(val),
            value, 
            setSearchValue: (val:string)=>setSearchValue(val),
            deleteId,
            setDeleteId: (val:string)=>setDeleteId(val),
            showList,
            setShowList: (val:boolean)=>showListemplates(val),
            spinner, 
            setSpinner: (val:boolean)=>showListemplates(val),
            location,
            userAccessDetail, 
            setUserAccessDetail: (val:IUserAccess[])=>setUserAccessDetail(val),
            sortByMenu,
            sortByText, 
            setSortByText:(val:any)=>setSortByText(val),
            filtering, 
            setFiltering: (val:boolean)=>handleFiltering(val),
            fetchCounter,
            setCounterQuery: (val:string)=>setCounterQuery(val),
            filterQuery, 
            setFilterQuery: (val:string)=>setFilterQuery(val),
            getQuerySearchFilters: (val:string)=>getQuerySearchFilters(val),
            move,
            deleteUserAccess: (id:string)=> deleteUserAccess(id),
            clearDeletedUserAccess: ()=> clearDeletedUserAccess()
        }}>
            {props.children}
        </UserAccessContext.Provider>
    )
}